import { ApplicabilityEnum, PriceBasisEnum } from '@msc-b2c/interfaces/enums';

export const shopExcursionMyMSCResponseMock = {
  code: 'LEG16',
  description: 'WALKING, BOATING AND SHOPPING IN LIVORNO',
  location: {
    code: 'LIV',
    name: 'Livorno, Italy',
  },
  startDate: '2025-08-25',
  applicableFor: ApplicabilityEnum.ALL,
  type: 'CITYTOUR',
  priceBasis: PriceBasisEnum.PER_PERSON,
  minimumPassengersRequired: 25,
  isPackage: false,
  guideLanguages: ['ENG', 'ITA', 'FRA', 'DEU', 'ESP'],
  prices: {
    taxes: {
      afterDiscount: '0.00',
      beforeDiscount: '0.00',
    },
    total: {
      afterDiscount: '62.00',
      beforeDiscount: '62.00',
    },
    perPassenger: [
      {
        isApplicable: true,
        number: 1,
        age: 43,
        total: {
          afterDiscount: '62.00',
          beforeDiscount: '62.00',
        },
        taxes: {
          afterDiscount: '0.00',
          beforeDiscount: '0.00',
        },
      },
    ],
  },
};
